import PropTypes from 'prop-types'
import { ObjectControlFlags } from '../../models/vehicle/object-control-flags-enum'

export const objectControlFlagPropType = PropTypes.arrayOf(PropTypes.oneOf(Object.values(ObjectControlFlags)))
